import { types } from './user.types';

export const setUserSelectedLocation = (data = {}) => ({
    type: types.SET_USER_SELECTED_LOCATION_INFO,
    payload: data,
});

/**
 * Set the effective agency ID for the current user.
 * For LYT roles this is driven by the sidebar agency selector.
 * For non-LYT roles this is set from their assigned agency on login.
 * @param {string} agencyId
 */
export const setUserAgencyId = (agencyId) => ({
    type: types.SET_USER_AGENCY_ID,
    payload: agencyId,
});



export const getUserPersonalInformationRequest = () => ({
    type: types.GET_USER_PERSONAL_INFORMATION_REQUEST,
});

export const getUserPersonalInformationSuccess = (data) => ({
    type: types.GET_USER_PERSONAL_INFORMATION_SUCCESS,
    payload: data,
});

export const getUserPersonalInformationError = (error) => ({
    type: types.GET_USER_PERSONAL_INFORMATION_ERROR,
    payload: error,
});

export const setUserPersonalInformation = (data) => ({
    type: types.SET_USER_PERSONAL_INFORMATION,
    payload: data,
});

export const setUserPersonalInformationRequest = () => ({
    type: types.SET_USER_PERSONAL_INFORMATION_REQUEST,
});

export const setUserPersonalInformationSuccess = (data) => ({
    type: types.SET_USER_PERSONAL_INFORMATION_SUCCESS,
    payload: data,
});

export const setUserPersonalInformationError = (error) => ({
    type: types.SET_USER_PERSONAL_INFORMATION_ERROR,
    payload: error,
});

export const clearUserStoredInformation = () => ({
    type: types.CLEAR_USER_STORED_INFO,
});

export const changePasswordRequest = () => ({
    type: types.CHANGE_PASSWORD_REQUEST
});

export const changePasswordSuccess = (data) => ({
    type: types.CHANGE_PASSWORD_SUCCESS,
    payload: data
});

export const changePasswordError = (error) => ({
    type: types.CHANGE_PASSWORD_ERROR,
    payload: error
});

export const setUserTheme = (data) => ({
    type: types.SET_USER_THEME,
    payload: data,
});

export const setUserName = (data) => ({
    type: types.SET_USER_NAME,
    payload: data
});
